import React, { useCallback, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';

import { ButtonSimple, DateFilter, Select } from '../index';

import { actions } from '../../state';
import { connect } from 'react-redux';

import styles from './monitoringActions.module.scss';

const MonitoringActions = ({
  dispatch,
  locations: { locations },
  filteredBody,
  locationId,
  setLocationId,
  dateToGtFilter,
  setDateToGtFilter,
  dateFromLtFilter,
  setDateFromLtFilter,
  handleSubmit,
  clearFilters,
}) => {
  const fetchLocations = useCallback(() => {
    dispatch(
      actions.locations.getLocationsAction({
        limit: 1000,
        offset: 0,
        order: [
          {
            by: 'full_address',
            order: 'asc',
          },
        ],
      })
    );
  }, [dispatch]);

  useEffect(() => {
    fetchLocations();
  }, [fetchLocations]);

  const availableLocations = useMemo(
    () => [
      { name: 'Visos lokacijos', value: '' },
      ...(locations || []).map(location => ({
        value: String(location.id),
        name: location.full_address || location.address || String(location.id),
      })),
    ],
    [locations]
  );

  return (
    <div className={styles.monitoringFilters}>
      {!!Object.values(filteredBody || {}).filter(Boolean).length && (
        <ButtonSimple type="filter" onClick={clearFilters}>
          Išvalyti filtrus
        </ButtonSimple>
      )}
      <div className={styles.dateFilter}>
        <DateFilter
          title="Pasirinkite laikotarpį"
          name="date_range"
          lt={dateToGtFilter}
          setLt={setDateToGtFilter}
          gt={dateFromLtFilter}
          setGt={setDateFromLtFilter}
          onSubmit={handleSubmit}
          inLocations
          isActive={false}
          icon="chevron-down"
          iconClass={styles.dateFilterIcon}
          ranges={[
            { name: 'Šis mėnuo', range: 'thisMonth' },
            { name: 'Praėjęs mėnuo', range: 'lastMonth' },
            { name: 'Šie metai', range: 'thisYear' },
            { name: 'Praėję metai', range: 'lastYear' },
          ]}
          showMonthYearPicker={true}
          dateFormat="yyyy.MM"
        />
      </div>
      <div className={styles.locationsSelectWrapper}>
        <Select
          name="location_id"
          options={availableLocations}
          selectedValue={locationId}
          onChange={event => {
            setLocationId(event.target.value);
          }}
          className={styles.locationsSelect}
        />
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  locations: state.locations,
});

MonitoringActions.propTypes = {
  dispatch: PropTypes.func.isRequired,
  locations: PropTypes.shape({
    locations: PropTypes.array.isRequired,
  }).isRequired,
  filteredBody: PropTypes.object.isRequired,
  locationId: PropTypes.string.isRequired,
  setLocationId: PropTypes.func.isRequired,
  dateToGtFilter: PropTypes.number,
  setDateToGtFilter: PropTypes.func.isRequired,
  dateFromLtFilter: PropTypes.number,
  setDateFromLtFilter: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  clearFilters: PropTypes.func.isRequired,
};

export default connect(mapStateToProps)(MonitoringActions);
